import React from 'react';

import {
    EsriGlobalNav,
    SiteNav,
    TopBanner,
    IntroSection,
    FiftyFifty,
    ExploreCards,
    EmbeddedApp
} from '../../components';

import BannerImage from '../../statics/img/banner.jpg';

import { SITE_NAME, TOP_BANNER_DESCRIPTION, TOP_BANNER_TITLE } from '../../constants/site';

const RootPage = () => {

    return (
        <>
            <EsriGlobalNav />
            <SiteNav title={SITE_NAME} />
            <TopBanner
                title={TOP_BANNER_TITLE}
                subTitle={TOP_BANNER_DESCRIPTION}
                backgroundImageURL={BannerImage}
            />
            <IntroSection />
            <ExploreCards />
            <FiftyFifty />
            <EmbeddedApp />
        </>
    );
};

export default RootPage;
